import React from "react";

export type courtCoachType = { [key: string]: string[] };

// GZ#2271 (Stackd): the day's occupancy read per sport, so a club running
// courts AND a wellness room can tell the two apart on the calendar header.
// Empty for single-sport locations — those keep exactly the header they had.
export type sportOccupancy = {
  sport_name: string;
  sport_ids: number[];
  court_count: number;
  occupied_hours: number;
  available_hours: number;
  occupancy_rate: number;
};

export type rateDetails = {
  bookingPercent: number;
  eventPercent: number;
  lessonPercent: number;
  noShowCounts: number;
  openMatchCounts: number;
  pendingPayments: number;
  unfilledOpenMatchCounts: number;
  dailyOccupancyRate: string;
  dailyOccupancyHours: number;
  by_sport?: sportOccupancy[];
  // GZ#3999 (opt-in clubs only, e.g. ISD Dubai): occupancy per court group
  // (Indoor / Outdoor) and the day's net revenue. Absent for every other club.
  by_court_group?: courtGroupOccupancy[];
  net_revenue?: dailyNetRevenue;
};

export type courtGroupOccupancy = {
  label: string;
  sport_ids: number[];
  court_count: number;
  occupied_hours: number;
  available_hours: number;
  occupancy_rate: number;
};

export type dailyNetRevenue = {
  currency: string | null;
  vat_rate: number;
  includes_unpaid: boolean;
  paid_revenue: number;
  unpaid_revenue: number;
  gross_revenue: number;
  net_revenue: number;
  booked_hours: number;
  net_revenue_per_hour: number;
  // Same money (gross, before VAT) and hours per sport, so the sport filter
  // can narrow revenue and hours together.
  by_sport?: netRevenueSportRow[];
};

export type netRevenueSportRow = {
  sport_id: number;
  paid_revenue: number;
  unpaid_revenue: number;
  booked_hours: number;
};

export interface coachmonthtstats {
  occupancyRate: number;
  overallTotalEventsHours: number;
  eventPercent: number;
  overallTotalLessonsHours: number;
  lessonsPercent: number;
}

export type monthlyRate = {
  bookingPercentage: number;
  lessonPercentage: number;
  eventPercentage: number;
  openMatchCounts: number;
  totalPendingPayments: number;
};

export type userData = {
  id: number;
  name: string;
  duration: number;
};

export type courtMonthlyStats = {
  occupiedHours: number;
  occupancyRate: number;
  // GZ#2271 (Stackd): same month, read per sport. Empty below two sports.
  by_sport?: { sport_name: string; court_count: number; occupancyRate: number; occupiedHours: number }[];
};

export type weeklyRate = {
  coachesDetails: userData[];
  noShowCounts: number;
  pendingPayments: number;
};

export type NotificationType = {
  message: string;
  type: string;
  subMessage: string;
  isShow: boolean;
};

export type locationTypes = {
  id: number;
  location_name: string;
  currency: string;
  timezone?: string;
};

// Define the type for your context
export interface MainContextType {
  UpdatePayments: boolean;
  chatURL: string;
  setChatURL: React.Dispatch<React.SetStateAction<string>>;
  SelectedLocation: locationTypes;
  setSelectedLocation: React.Dispatch<React.SetStateAction<locationTypes>>;
  setCourtMonthlystats: React.Dispatch<React.SetStateAction<courtMonthlyStats>>;
  courtMonthlyStats: courtMonthlyStats;
  setUpdatePayments: React.Dispatch<React.SetStateAction<boolean>>;
  authenticated: boolean;
  selectedLocationId: number;
  setMobileSideBar: React.Dispatch<React.SetStateAction<boolean>>;
  MobileSideBar: boolean;
  setSelectedLocationId: any;
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  selectedCustomerid: any;
  setSelectedCustomerId: any;
  resServicesList: any;
  setServicesList: any;
  sideBar: boolean;
  sport_id: any;
  setSport_id: any;
  setLoginData: any;
  LoginData: any;
  setSelectedCourtDurations: any;
  SelectedCourtDurations: any;
  setSideBar: React.Dispatch<React.SetStateAction<boolean>>;
  ActiveTab: string;
  selectedMonth: any;
  setSelectedMonth: any;
  setNotification: React.Dispatch<React.SetStateAction<NotificationType>>;
  Notification: NotificationType;
  customerList: any;
  setCustomerList: any;
  setSelectedClickEvent:React.Dispatch<React.SetStateAction<any>>;
  selectedClickEvent: any;  
  BackgroundEvent: any;
  setBackgorundEvent: React.Dispatch<React.SetStateAction<any>>;
  setIsCancelBooking:React.Dispatch<React.SetStateAction<boolean>>;
  isCancelBooking: boolean;
  playerList: any;
  setPlayerList: any;
  setIsPermissionOn: any;
  isPermissionOn: any;
  setCoachMonthStats: React.Dispatch<React.SetStateAction<coachmonthtstats>>;
  event: any;
  CoachMonthStats: coachmonthtstats;
  setEvent: any;
  setSelectedRegion: React.Dispatch<React.SetStateAction<any>>;
  selectedRegion: any;
  selectedCourt: any[];
  setselectedCourt: React.Dispatch<React.SetStateAction<any[]>>;
  selectedPlayers: any;
  servicePlayers: any;
  setServicePlayers: any;
  setSelectdPlayers: any;
  ratingDetails: rateDetails;
  setRatingDetails: React.Dispatch<React.SetStateAction<rateDetails>>;
  monthlyGraph: monthlyRate;
  setMonthlyGraph: React.Dispatch<React.SetStateAction<monthlyRate>>;
  weeklyGraph: weeklyRate;
  setWeeklyGraph: React.Dispatch<React.SetStateAction<weeklyRate>>;
  selCustomer: any;
  setSelCustomer: any;
  selPlayer: any;
  setSelPlayer: any;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  courts: { [key: string]: string[] };
  setCourts: React.Dispatch<React.SetStateAction<courtCoachType>>;
  coaches: { [key: string]: string[] };
  setCoaches: React.Dispatch<React.SetStateAction<courtCoachType>>;
  serviceList: any;
  setServiceList: React.Dispatch<React.SetStateAction<any>>;
  selectedDate: Date;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date>>;
  CancelledPlayer: any;
  setCancelledPlayer: any;
  onDragCourt: any;
  setOnDragCourt: React.Dispatch<React.SetStateAction<any>>;
  isChatVisible: boolean;
  setIsChatVisible: React.Dispatch<React.SetStateAction<boolean>>;
  hasUnreadSupport: boolean;
  setHasUnreadSupport: React.Dispatch<React.SetStateAction<boolean>>;
  calendarSearchQuery: string;
  setCalendarSearchQuery: React.Dispatch<React.SetStateAction<string>>;
}

const MainContext = React.createContext<MainContextType>({} as MainContextType);

export default MainContext;
